import React, { FC } from 'react'
import { RouteComponentProps } from 'react-router-dom'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
import translate from 'loankeeper-common/helpers/language'

import { useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { actions as DetailsContainerActions } from '../../../../DetailsContainer'
import { deleteClientRelationConfModal, deleteClientRelationFetcher } from '../../../constants'
import { AppDispatch } from 'src/store/index.d'
import { deleteClientRelation } from 'src/store/client'

const Modals: FC<{
  history: RouteComponentProps['history']
  location: RouteComponentProps['location']
  match: {
    path: string
    url: string
    isExact: boolean
    params: {
      ID: string
      hash: string
      type: string
    }
  }
}> = ({ match }) => {
  const dispatch = useDispatch<AppDispatch>()

  async function handleConfirm({
    RLClientID,
    RLHash,
    ClientID,
  }: {
    RLClientID: number
    RLHash: string
    ClientID: number
  }) {
    const { ID, hash } = match.params
    // dispatch(
    //   fetchSFM({
    //     instanceName: deleteClientRelationFetcher,
    //     callApi: Client.deleteRelation,
    //     callApiArgs: [ID, hash, ClientID, RLClientID, RLHash],
    //     resolve: () =>
    //       dispatch(
    //         DetailsContainerActions.fetchPage({
    //           type: 'Client',
    //           ID,
    //           hash,
    //           page: 'relations',
    //         }),
    //       ),

    //     reject: (error) => {
    //       dispatch(LKModalActions.openError(translate('LKMESSAGE', error.Error.Message || error.Error.Text)))
    //     },
    //   }),
    // )

    //UPDATED API REQUEST client_oper_post page:relationdelete
    const res = await dispatch(
      deleteClientRelation({
        ClientID: ID,
        clientHash: hash,
        RLClientID: ClientID,
        RelationID: RLClientID,
        RelationClientHash: RLHash,
      }),
    )
    if (deleteClientRelation.fulfilled.match(res)) {
      dispatch(
        DetailsContainerActions.fetchPage({
          type: 'Client',
          ID,
          hash,
          page: 'relations',
        }),
      )
    } else if (deleteClientRelation.rejected.match(res)) {
      //@ts-ignore
      dispatch(LKModalActions.openError(translate('LKMESSAGE', res.payload.message)))
    }
  }

  return <LKModal.Confirmation name={deleteClientRelationConfModal} onConfirm={handleConfirm} warning />
}

export default withRouter(Modals)
